<template>
  <div class="guestbook-header">
    <!--v-if="headerContent.isPersonalGreetingVisible && (headerContent.includeName || headerContent.includeRoom)" -->
    <!-- <div
      class="guestbook-header__header"
      :style="{
        'background-color': headerContent.backgroundColor,
        color: headerContent.textColor
          ? headerContent.textColor
          : getCorrectTextColor(),
      }"
    >
    </div> -->
    <div
      class="guestbook-header__main"
      :style="{
        color: headerContent.textColor
          ? headerContent.textColor
          : getCorrectTextColor(),
      }"
    >
      <div v-on:click="editThis()" class="editIcon">
        <v-icon class="icon" name="pencil-alt" scale="1.5"></v-icon>
      </div>
      <div
        v-if="headerContent.imageActive"
        :style="{ 'background-color': headerContent.backgroundColor }"
        class="guestbook-header__main__image-container"
      >
        <img v-bind:src="appropriateImage" />
      </div>
      <div
        v-else
        class="guestbook-header__main__video-container"
        :style="{ 'background-color': headerContent.backgroundColor }"
      >
        <div class="embed-container">
          <iframe
            v-bind:src="headerContent.videoPath"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div
        class="guestbook-header__main__text"
        style="overflow: hidden"
        :style="{ 'background-color': headerContent.backgroundColor }"
        v-html="contentHeaderText"
      ></div>
    </div>
    <transition name="fadeInModal">
      <header-edit v-if="showHeaderEdit" @close="closeEdit"></header-edit>
    </transition>
  </div>
</template>

<script>
import HeaderEdit from "./HeaderEdit";
import bus from "@/bus";

export default {
  components: {
    HeaderEdit,
  },
  props: {
    headerContent: Object,
    languageTypesIndex: Number,
  },
  data() {
    return {
      showHeaderEdit: false,
    };
  },
  computed: {
    contentHeaderText() {
      return this.headerContent.contents[this.languageTypesIndex];
    },
    appropriateImage() {
      // Check viewport
      if (window.matchMedia("(max-width: 500px)").matches) {
        return this.headerContent.imagePath;
      } else {
        var desktopImage = this.headerContent.imagePath.replace(
          encodeURIComponent(this.$hotelId) + "%2Fmobile%2Fmobile-375_",
          encodeURIComponent(this.$hotelId) + "%2Fdesktop%2Fdesktop-1000_"
        );
        return desktopImage;
      }
    },
  },
  methods: {
    editThis: function () {
      this.showHeaderEdit = true;
      bus.$emit("bodyOverflow", true);
    },
    closeEdit: function () {
      this.showHeaderEdit = false;
      bus.$emit("bodyOverflow", false);
    },
    getCorrectTextColor() {

      let hex = this.headerContent.backgroundColor;
      let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

      let hRed = hexToR(hex);
      let hGreen = hexToG(hex);
      let hBlue = hexToB(hex);

      function hexToR(h) {
        return parseInt(cutHex(h).substring(0, 2), 16);
      }
      function hexToG(h) {
        return parseInt(cutHex(h).substring(2, 4), 16);
      }
      function hexToB(h) {
        return parseInt(cutHex(h).substring(4, 6), 16);
      }
      function cutHex(h) {
        return String(h).charAt(0) == "#"
          ? String(h).substring(1, 7)
          : String(h);
      }

      let cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;
      if (cBrightness > threshold) {
        return "#000000";
      } else {
        return "#ffffff";
      }
    },
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 100%;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.guestbook-header {
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
  padding: 20px 20px 0 20px;
}

.guestbook-header__header {
  height: 52px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  margin-bottom: 20px;
}

.guestbook-header__header__item {
  display: flex;
  align-items: center;
}

.icon__person {
  margin: 0 8px 0 16px;
}

.icon__room {
  margin: 0 16px 0 8px;
}

.guestbook-header__main {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  position: relative;
}

.guestbook-header__main__image-container,
.guestbook-header__main__video-container {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 360px;
  border-radius: 8px 8px 0 0;
  overflow: hidden; /* Hide the corners not within the border-radius */
}

.guestbook-header__main__image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
}

.guestbook-header__main__text {
  width: 100%;
  padding: 16px;
  border-radius: 0 0 8px 8px;
  font-size: 12px;
  overflow-y: hidden;
}

/* Defaults on text from tiny MCE editor */
/* Use deep selector ">>>" for targeting v-html generated elements */
.guestbook-header__main__text >>> p,
.guestbook-header__main__text >>> h1,
.guestbook-header__main__text >>> h2,
.guestbook-header__main__text >>> h3,
.guestbook-header__main__text >>> h4,
.guestbook-header__main__text >>> h5,
.guestbook-header__main__text >>> h6 {
  margin: 0 0 12px 0;
  font-size: 12px;
}

/* Whatever textbox is last, dont add margin */
.guestbook-header__main__text >>> *:last-child {
  margin-bottom: 0;
}

.editIcon {
  width: 48px;
  height: 48px;
  position: absolute;
  top: -15px;
  right: -15px;
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  background-color: #3f3d39;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

@media screen and (min-width: 700px) {
  .guestbook-header {
    width: 700px;
    max-width: none;
  }
}

@media screen and (min-width: 1040px) {
  .guestbook-header {
    width: 1040px;
  }

  .guestbook-header__main {
    display: flex;
    flex-direction: row-reverse;
    height: 360px;
  }

  .guestbook-header__main__image-container,
  .guestbook-header__main__video-container {
    border-radius: 0 8px 8px 0;
  }

  .guestbook-header__main__text {
    max-width: 400px;
    border-radius: 8px 0 0 8px;
  }
}
</style>
